import { type LabColorDict, type LabColorInput, toLabColor } from './toLabColor'

export type Recipe = {
  component_names?: string[]
  ratios?: Array<number | string>
  thickness?: number | string | null
  opacity_category?: string | null
  targetLAB?: LabColorInput | null
  targetLAB_before_firing?: LabColorInput | null
}

export type RecipeView = {
  names: string[]
  ratios: Array<number | string>
  thickness?: number
  opacityCategory?: string
  targetLab?: LabColorDict
}

export const fromRecipe = (recipe?: Recipe | null): RecipeView => {
  const thicknessRaw = recipe?.thickness
  const thicknessNum =
    thicknessRaw == null || thicknessRaw === ''
      ? undefined
      : Number(thicknessRaw)
  const targetLab =
    toLabColor(recipe?.targetLAB_before_firing) ?? toLabColor(recipe?.targetLAB)
  const opacityCategory =
    typeof recipe?.opacity_category === 'string' && recipe.opacity_category
      ? recipe.opacity_category
      : undefined

  return {
    names: Array.isArray(recipe?.component_names) ? recipe.component_names : [],
    ratios: Array.isArray(recipe?.ratios) ? recipe.ratios : [],
    ...(thicknessNum != null && Number.isFinite(thicknessNum)
      ? { thickness: thicknessNum }
      : {}),
    ...(opacityCategory ? { opacityCategory } : {}),
    ...(targetLab ? { targetLab } : {}),
  }
}

export const fromRecipeList = (recipes: unknown): RecipeView => {
  const recipe = Array.isArray(recipes) ? recipes[0] : undefined
  return fromRecipe(recipe)
}
